import React from "react"
import { Wrapper, Title, Btns, Btn } from './feedback-block-styled'
import TelegramIcon from '~images/telegram-blue-icon.svg'
import MailIcon from '~images/mail-blue-icon.svg'

const FeedbackBlock = ({ title }: { title?: string }) => {
  return (
    <Wrapper>
      <Title>{title || 'или напишите нам:'}</Title>
      <Btns>
        <Btn href='https://t.me/onlinepbx_sales' target='_blank'><TelegramIcon /></Btn>
        <Btn href='mailto:go@onlinepbx.ru'><MailIcon /></Btn>
      </Btns>
    </Wrapper>
  )
}

export { FeedbackBlock }